import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import * as Yup from 'yup';
import { FormChanges } from 'utils';
import { Formik, Field } from 'formik';
import { Box, Grid, Button, Container, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import { VehiclesGroupsSelect } from 'components/AsyncFields';
import { buildUrl } from 'utils';

const CustomerGroups = ({ formRef, step, exit, onSave }) => {
  const dispatch = useDispatch();

  const formSchema = Yup.object().shape({
    vehicle_group_id: Yup.string().required(i18n.t('common.required_field')),
  });

  const initialValues = {
    vehicle_group_id: step?.vehicle_group?.id || '',
  };

  const onSubmit = (values) => {
    if (step?.vehicle_group?.id === values?.vehicle_group_id) {
      return dispatch(vehicleActions.changePosition('next', exit));
    }

    dispatch(
      vehicleActions.changeVehicleGroup(
        {
          group_id: values?.vehicle_group_id,
        },
        'customer_group',
        exit
      )
    );
  };

  return (
    <Box>
      <Container className="h-100">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid size={{ xs: 11 }}>
            <Formik
              innerRef={formRef}
              initialValues={initialValues}
              validationSchema={formSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ handleSubmit, values }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Grid size={{ xs: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        <Box sx={{ fontWeight: 'fontWeightBold', fontSize: 14, my: 1 }}>
                          {i18n.t('vehicle.vehicle_groups')}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <Field
                        name="vehicle_group_id"
                        component={VehiclesGroupsSelect}
                        customParams={{
                          group_type: 'CUSTOMER',
                          parent_id: step?.vehicle_group?.parent?.id,
                        }}
                        label={i18n.t('vehicle.vehicle_group_name')}
                      />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Box sx={{ mt: 3 }}>
                        <Button
                          color="primary"
                          target="_blank"
                          component="button"
                          variant="outlined"
                          href={buildUrl('/service-groups')}
                        >
                          {i18n.t('vehicle.add_vehicle_group')}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                  <FormChanges initialValues={initialValues} onSave={onSave} />
                </form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

CustomerGroups.propTypes = {
  formRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  step: PropTypes.object,
  exit: PropTypes.func,
  onSave: PropTypes.func,
};

export default CustomerGroups;
